import { ReactNode } from 'react';
import { create } from 'zustand';

interface LoginModalOptions {
	sessionExpired?: boolean;
	message?: ReactNode;
}

interface LoginModalStore {
	isOpen: boolean;
	sessionExpired: boolean;
	message: ReactNode;
	openLoginModal: (options?: LoginModalOptions) => void;
	closeLoginModal: () => void;
}

export const useLoginModalStore = create<LoginModalStore>((set) => ({
	isOpen: false,
	sessionExpired: false,
	message: null,
	openLoginModal: (options) =>
		set({
			isOpen: true,
			sessionExpired: options?.sessionExpired ?? false,
			message: options?.message ?? null,
		}),
	closeLoginModal: () => set({ isOpen: false, sessionExpired: false, message: null }),
}));
